import { Modifier } from '../../florence/types/Modifier';

export type CodeStatus = 'correct' | 'incorrect';

export type ICD10Code = {
  code: string;
  description: string;
  selected: boolean;
  source?: 'galeai' | 'athena' | 'confirmed';
};

export type Code = {
  code: string;
  description: string;
  multiplier: number;
  modifiers: Modifier[] | string[];
  isFlagged?: boolean;
  order?: number;
  work_rvu?: string;
  non_facility_total?: string;
  facility_total?: string;
  relevant?: boolean;
  invalidCombos?: CodeInvalidReason[];
  manuallyAdded?: boolean;
  id: string;
  codeId?: number;
  sheetId?: number;
  searchResultId?: number;
  isPrimaryCode?: boolean;
  from?: 'galeai' | 'athena' | 'confirmed' | 'user';
  icd10?: ICD10Code[];
  selected?: boolean;
};

export type SheetCode = Omit<SelectableCode, 'modifiers'> & {
  modifiers: string[];
};

export type SavedCode = {
  id: number;
} & Code;

export type SelectableCode = {
  selected: boolean;
} & Code;

// User friendly reason why code combination is invalid
export type CodeInvalidReason = {
  code: string;
  reason: string;
};

// This should only return a result if CodeStatus is 'incorrect', reasons should list the relevant conflicts and reason for the conflict based off of PtpResult enum
export type CodeCombination = {
  code: string;
  status: CodeStatus;
  reasons?: CodeInvalidReason[];
};

export enum PtpResult {
  NoModifierNeeded = 'NO_MODIFIER_NEEDED',
  AllowedWithModifier = 'ALLOWED_WITH_MODIFIER',
  NotAllowed = 'NOT_ALLOWED',
}

export type CombinationResult = {
  code_1: string;
  code_2: string;
  ptp_result: PtpResult;
};

export type CciResult = {
  codes: CodeCombination[];
  results: CombinationResult[];
};
